// Mirrors PHONE_SIGN_IN_PATH in backend/src/lib/placetelPhoneAccount.ts. Webex
// sends agents back to this portal path after their one-time phone sign-in; it
// must match a redirect URI registered for the phone sign-in app.
export const PHONE_SIGN_IN_PATH = "/phone-sign-in";
